import * as ROUTES from './ROUTES';

export const MENU_HOME = {
  icon: 'mdi-home-outline',
  label: ['Home'],
  route: ROUTES.ROUTE_HOME.path,
};

export const MENU_COLETA = {
  icon: 'mdi-cash-register',
  label: ['Coleta Peças'],
  route: ROUTES.ROUTE_COLETA_LISTA.path,
};

export const MENU_PRESTACAOSERVICO = {
  icon: 'mdi-account-wrench ',
  label: ['Prestação Serviço'],
  route: ROUTES.ROUTE_PRESTACAOSERVICO.path,
};




// ORDEM DO MENU

export default [
  MENU_HOME,
  MENU_COLETA,
  MENU_PRESTACAOSERVICO
];

export function menuMapper(componentInstance, menus) {
  return [].concat(menus).map((menu) => ({
    ...menu,
    label: String(...menu.label),
  }));
}
